import { _ as _ListCache } from "./auth-service-tools1182.js";
import { _ as _stackClear } from "./auth-service-tools1183.js";
import { _ as _stackDelete } from "./auth-service-tools1184.js";
import { _ as _stackGet } from "./auth-service-tools1185.js";
import { _ as _stackHas } from "./auth-service-tools1186.js";
import { _ as _stackSet } from "./auth-service-tools1187.js";
var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var _Stack = Stack;
export { _Stack as _ };